import {RewardsProps} from './rewards.types';
import {Reward} from '../reward/reward';

export const Rewards = ({list}: RewardsProps): JSX.Element => {
	return (
		<div>
			{list.map((reward) => (
				<Reward key={reward.title} {...reward} />
			))}
		</div>
	);
};
